<template>
  <ul v-if="tracks" class="c-playlist c-playlist--large c-playlist--dividers">
      <li class="c-playlist__item" v-for="track in tracks" :key="track.start">
          <div class="o-playlist">
              <div class="o-playlist__position">
                {{ track.start }}
              </div>

              <div class="o-playlist__image">
                  <img v-if="track.thumbnail" :src="cdnUrl(track.thumbnail, 'cover/w300')" :alt="track.title">
              </div>
              <div class="o-playlist__content">
                  <h3 class="o-playlist__title">{{track.title}}</h3>
                  <p class="o-playlist__artist">{{track.artist}}</p>
              </div>
              <div class="o-playlist__actions">
                <PreviewTrack :url="track.hooks.m4a" v-if="track.hooks.m4a" />
                <Like :selectorCode="track.selectorCode" />
                <TrackActionSheet :hooks="track.hooks" />
              </div>
          </div>
      </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex';
import Like from '../like/Like';
import PreviewTrack from '../tracks/PreviewTrack';
import TrackActionSheet from '../tracks/TrackActionSheet';
import {cdnUrl} from '@general/filters/imageFilters'

export default {
  name: 'TrackList',
  computed: mapState({
    tracks: state => state.playlist.tracks,
  }),
  methods: {
    cdnUrl
  },
  components: {
    Like,
    TrackActionSheet,
    PreviewTrack,
  },
};
</script>
